import urlBuilder from '@sanity/image-url';
import {FormEvent, useState} from 'react';
import {useSanityClient} from '~/lib/utils';
import {SanityBlockSubscribe} from '~/types/sanityTypes';

export function BlockSubscribe({
  blockContent,
}: {
  blockContent: SanityBlockSubscribe;
}) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    if (!email) {
      return false;
    }
    setLoading(true);
    setError('');

    const promise = await fetch('/api/subscribeToNewsLetter', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({email}),
    });

    // Log the response from our API route
    const responseJson = await promise.json();

    if (responseJson.error) {
      setError(responseJson.error);
    } else {
      setSuccess(true);
    }

    setLoading(false);
  };

  const backgroundSrc = blockContent.image
    ? urlBuilder(useSanityClient)
        .image(blockContent.image)
        .width(1200)
        .fit('max')
        .auto('format')
        .url()
    : '';
  const backgroundStyle = backgroundSrc
    ? {
        backgroundImage: `url(${backgroundSrc})`,
        backgroundPosition: '50% 50%',
        backgroundSize: 'cover',
      }
    : {};

  return (
    <div className="block-subscribe">
      <div className="container">
        <div className="grid py-6 md:py-12">
          <div
            style={backgroundStyle}
            className="text-white bg-black px-4 py-10 grid items-start grid-cols-1 gap-4 md:p-10 md:grid-cols-2 md:gap-6"
          >
            <div>
              <h3>{blockContent.title}</h3>
            </div>
            <div>
              {success && <h3>Kiitos!</h3>}
              {!success && (
                <form
                  action="/api/subscribeToNewsLetter"
                  method="post"
                  onSubmit={handleSubmit}
                >
                  <div className="md:flex">
                    <div className="grow md:pr-4">
                      <input
                        className="text-black text-sm w-full py-[0.84rem]"
                        type="email"
                        name="email"
                        value={email}
                        placeholder="Sähköposti"
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      {error && (
                        <p className="bg-red-400 text-xs p-1">{error}</p>
                      )}
                    </div>
                    <div className="pt-4 md:pt-0">
                      <button
                        className="newsLetterButton w-full"
                        type="submit"
                        disabled={loading}
                      >
                        Tilaa uutiskirje
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
